import { LAYOUT } from '../constants'

/**
 * @type {import('vue-router').RouteConfig[]}
 */
export default [
  {
    path: '/history',
    component: LAYOUT,
    redirect: '/history/index',
    meta: { title: '而立华联', showNavPanel: true },
    children: [
      {
        path: 'index',
        name: '而立华联',
        component: () => import('@/views/history/index.vue'),
        meta: { title: '而立华联', hide: true, showNavPanelBorder: false },
      },
      {
        path: 'person',
        name: '华联人物',
        component: () => import('@/views/history/person.vue'),
        meta: { title: '华联人物' },
      },
      {
        path: 'story',
        name: '华联故事',
        component: () => import('@/views/history/story.vue'),
        meta: { title: '华联故事' },
      },
      {
        path: 'article',
        name: '校友文苑',
        component: () => import('@/views/history/article.vue'),
        meta: { title: '校友文苑' },
      },
      {
        path: 'pulpit',
        name: '校友讲坛',
        component: () => import('@/views/history/pulpit.vue'),
        meta: { title: '校友讲坛' },
      },
      {
        path: 'achievement',
        name: '校友视界',
        component: () => import('@/views/history/achievement.vue'),
        meta: { title: '校友视界' },
      },
    ],
  },
]
